import React, { useEffect, useState } from "react";
import {
  Container,
  Grid,
  Typography,
  Chip,
  Box,
  Avatar,
  IconButton,
  Divider,
} from "@mui/material";
import {
  Favorite,
  Share,
  BookmarkBorder,
  Facebook,
  Twitter,
  LinkedIn,
} from "@mui/icons-material";
import { useParams } from "react-router-dom";
import picture from "@assets/images/Downtown_Dubai.webp";
import axios from "axios";
import SEO from "../../../utils/SeoComponent";
const DESCO_API_BASE = import.meta.env.VITE_DESCO_API_BASE;

const BlogDetail = () => {
  const [isLiked, setIsLiked] = useState(false);
  const { slug } = useParams(); // get blogPost id from URL
  const [blog, setBlog] = useState(null);

  useEffect(() => {
    // Fetch the blog by ID (using Axios)
    const fetchBlog = async () => {
      try {
        const response = await axios.get(
          `${DESCO_API_BASE}/blog/index/${slug}`
        );
        setBlog(response.data); // Set the response data to state
      } catch (err) {
        console.error("Failed to fetch blog:", err);
      }
    };

    fetchBlog();
  }, [slug]);

  const blogPost = blog?.data?.[0];

  const metaTitle = "test";
  const metaDescription = "testing blog detail page description";

  return (
    <>
      <SEO slug={"blogdetailpage"} title={metaTitle} description={metaDescription} />

      <Container maxWidth="lg" sx={{ py: 8, mt: { xs: 6, md: 14 } }}>
        <Box sx={{ mb: 6, maxWidth: 800, mx: "auto" }}>
          <Chip
            label={blogPost?.type}
            sx={{
              mb: 3,
              background: "linear-gradient(45deg, #C10E14 30%, #F44336 90%)",
              color: "white",
            }}
          />
          <Typography
            variant="h3"
            component="h1"
            sx={{ mb: 3, fontWeight: 700 }}
          >
            {blogPost?.title}
          </Typography>

          <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 4 }}>
            <Avatar
              alt={blogPost?.author}
              src={blogPost?.image}
              sx={{ width: 56, height: 56 }}
            />
            <Box>
              <Typography variant="h6">{blogPost?.user_name}</Typography>
              <Typography variant="body2" color="text.secondary">
                {blogPost?.created_at ? (
                  <>
                    {new Intl.DateTimeFormat("en-GB", {
                      day: "2-digit",
                      month: "short",
                      year: "numeric",
                      hour: "2-digit",
                      minute: "2-digit",
                      hour12: false,
                    }).format(new Date(blogPost.created_at))}

                    {blogPost?.readTime}
                  </>
                ) : (
                  "Loading..."
                )}
              </Typography>
            </Box>
          </Box>
        </Box>

        <Box sx={{ mb: 6 }}>
          <img
            src={blogPost?.image}
            alt={blogPost?.title}
            style={{
              width: "100%",
              height: "auto",
              borderRadius: "12px",
              boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
            }}
          />
        </Box>

        <Grid container spacing={4}>
          <Grid item xs={12} md={12}>
            <Typography variant="body1" sx={{ mb: 4, lineHeight: 1.8 }}>
              {blogPost?.description}
            </Typography>

            <Box sx={{ display: "flex", gap: 2, mb: 4 }}>
              <IconButton
                onClick={() => setIsLiked(!isLiked)}
                sx={{
                  color: isLiked ? "error.main" : "inherit",
                }}
              >
                <Favorite />
              </IconButton>
              <IconButton>
                <Share />
              </IconButton>
              <IconButton>
                <BookmarkBorder />
              </IconButton>
            </Box>

            <Divider sx={{ mb: 4 }} />

            <Box sx={{ mb: 6 }}>
              <Typography variant="h6" sx={{ mb: 2 }}>
                Share this article
              </Typography>
              <Box sx={{ display: "flex", gap: 2 }}>
                <IconButton sx={{ color: "#1877F2" }}>
                  <Facebook />
                </IconButton>
                <IconButton sx={{ color: "#1DA1F2" }}>
                  <Twitter />
                </IconButton>
                <IconButton sx={{ color: "#0A66C2" }}>
                  <LinkedIn />
                </IconButton>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default BlogDetail;
